<template>
  <div class="footer">
    <div class="content" v-show="type==1||type=='hr'">
      <div class="yly-content">
        <div class="tel">
          <a href="https://www.yilieyun.com" title="易猎云招聘管理系统">
          <img
            class="homelogo"
            @click="gotohome"
            src="https://img.yilieyun.com/oss/ylyofficialWebImagse/foot-logo@2x.png"
            alt=""
          />
          </a>
          <div class="content-tel">
            <img
              src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon2_telephone@2x.png"
              alt=""
            />
            <span>400-0588-036</span>
          </div>
        </div>
        <div class="text-content">
          <div class="text">
            <a @click="gotohome">首页</a>
            <a @click="gotoproduct">产品</a>
            <a @click="gotoprice">价格</a>
            <!-- <a @click="gotoabout">帮助</a> -->
            <a
              href="https://help.yilieyun.cn"
              style="color: #fff"
              target="_blank"
              >帮助</a
            >
          </div>
          <div class="footer">
            <p>©2018-{{year}} 易猎云（海南）科技公司</p>
            <p style="margin-top: 15px">
              <a href="https://beian.miit.gov.cn/" target="view_window">琼ICP备2021005894号-{{id}}</a>
            </p>
          </div>
        </div>
        <div class="img-code">
          <img
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/pic_QR%20code%402x.png"
            alt=""
          />
          <p>易猎云公众号</p>
        </div>
      </div>
    </div>
    <!--大屏-->
    <div class="largebox" v-show="type==2">
      <div class="large_container">
        <div class="con_left">
          <img src="https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/yl_gglogo%402x.png"/>
        </div>
        <div class="con_center">
          <p class="text1">助力企业数字化转型</p>
          <p class="text2">易猎云可视化大屏</p>
        </div>
        <div class="con_right">
          <span class="tel_box">
            <img class="tel_icon" src="https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/icon_hhtelephone%402x.png"/>
            <span class="tel_text">联系电话</span>
            <span class="tel_tel">400-0588-036</span>
          </span>
        </div>
      </div>
      <div style="text-align:center;font-size:16px;color:#ffffff;margin-top:50px">易猎云版权所有 ©2018-2022</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routeData: {},
      id:1,
      year:''
    };
  },
  props:['type'],
  mounted() {
    console.log('域名',window.location.host);
    if(window.location.host=='www.yilieyun.com'){
      this.id=1;
    }else if(window.location.host=='www.yilieyun.cn'){
      this.id=2;
    }else{
      this.id=1;
    }
    if (Object.keys(this.$route.query).length) {
      this.routeData = this.$route.query;
    }
    let date = new Date();
    this.year = date.getFullYear(); //获取完整的年份(4位)
  },
  methods: {
    gotohome() {
      this.$router.push({
        path: "/",
        query: this.routeData,
      });
      // 让页面回到顶部
      document.documentElement.scrollTop = 0;
    },
    gotoproduct() {
      this.$router.push({
        path: "/product",
        query: this.routeData,
      });
      // 让页面回到顶部
      document.documentElement.scrollTop = 0;
    },
    gotoprice() {
      this.$router.push({
        path: "/price",
        query: this.routeData,
      });
      // 让页面回到顶部
      document.documentElement.scrollTop = 0;
    },
    gotoabout() {
      this.$router.push({
        path: "/about",
        query: this.routeData,
      });
      // 让页面回到顶部
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";

.footer {
  .largebox{
    width: 100%;
    height: 296px;
    background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/bg_bannerlarge%402x.png');
    background-repeat: no-repeat;
    background-size: 100%;
    padding-top: 87px;
    box-sizing: border-box;
    .large_container{
      width: 1200px;
      display: flex;
      margin: 0 auto;
      .con_left{
        margin-left: 80px;
        img{
          width: 85px;
          height: 50px;
          vertical-align: middle;
        }
      }
      .con_center{
        .text1{
          font-size: 40px;
          color: #ffffff;
          vertical-align: middle;
          margin-top: 20px;
          margin-left: 30px;
        }
        .text2{
          font-size: 22px;
          color: #ffffff;
          margin-top: 30px;
          margin-left: 100px;
        }
      }
      .con_right{
        .tel_box{
          display: inline-block;
          width: 442px;
          height: 62px;
          background: #ffffff;
          border-radius: 30px;
          margin-left: 130px;
          .tel_icon{
            display: inline-block;
            width: 31px;
            height: 31px;
            margin-top: 16px;
            margin-left: 50px;
            vertical-align: middle;
          }
          .tel_text{
            display: inline-block;
            font-size: 24px;
            vertical-align: middle;
            margin-top: 16px;
            margin-left: 14px;
          }
          .tel_tel{
            display: inline-block;
            font-size: 24px;
            color: #1E78FF;
            vertical-align: middle;
            margin-top: 16px;
            margin-left: 18px;
          }
        }
      }
    }
  }
  .content {
    width: 100%;
    height: 380px;
    background: #373E5D;
    padding-top: 87px;
    box-sizing: border-box;
    .content__img {
      width: 1200px;
      height: 138px;
      margin: 0 auto;

      div {
        width: 153px;
        height: 42px;
        margin-top: 77px;
      }

      .container {
        width: 1029px;
        height: 61px;
        margin-top: 87px;

        a {
          display: inline-block;
          font-size: 18px;
          color: #ffffff;
          margin-left: 155px;
          cursor: pointer;
        }
      }
    }

    .content__tel {
      position: relative;
      width: 1200px;
      height: 30px;
      margin: 0 auto;
      margin-top: 36px;

      img {
        width: 27px;
        height: 30px;
      }

      span {
        position: absolute;
        font-size: 22px;
        color: #ffffff;
        left: 35px;
        top: 4px;
      }
    }

    .content__copyright {
      width: 1200px;
      height: 60px;
      margin: 0 auto;
      margin-top: 68px;

      p {
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        margin-top: 15px;

        a {
          color: #ffffff;
        }
      }
    }
  }

  .homelogo {
    cursor: pointer;
  }

  .yly-content {
    width: 1490px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;

    .tel {
      width: 200px;
    }

    .homelogo {
      width: 153px;
      height: 42px;
    }

    .content-tel {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin-top: 45px;
      align-items: center;

      img {
        width: 27px;
        height: 30px;
      }

      span {
        font-size: 22px;
        color: #ffffff;
      }
    }

    .text-content {
      height: 230px;
      margin-top: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .text {
        display: inline-block;
        font-size: 20px;
        color: #ffffff;
        cursor: pointer;
        width: 630px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
      }

      .footer {
        font-size: 14px;
        color: #ffffff;
        text-align: center;

        a {
          color: #ffffff;
        }
      }
    }

    .img-code {
      margin-top: 18px;

      img {
        display: block;
        width: 170px;
        height: 170px;
      }

      p {
        color: #ffffff;
        font-size: 18px;
        margin-top: 11px;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/footer/index.vue